module.exports = __webpack_public_path__ + "static/media/signup-icon-02.8354ad5b.svg";